import { n$2, t$2 } from '@/js/global/global'
import { shouldAnimate, wrapIframes, wrapTables } from '@/js/global/helpers'
import { register } from '@/js/global/shopify-theme-sections'
import { animateArticle } from '@/js/global/animations'
import { focusFormStatus } from '@/js/global/a11y-user'
import { SocialShare } from '@/js/modules/social-share'


register("article", {
  onLoad() {
    focusFormStatus(this.container);
    const socialShareContainer = n$2(".social-share", this.container);
    if (socialShareContainer) {
      this.socialShare = SocialShare(socialShareContainer);
    }
    wrapIframes(t$2("iframe", this.container));
    wrapTables(t$2("table", this.container));
    if (shouldAnimate(this.container)) {
      this.animateArticle = animateArticle(this.container);
    }
  },
  onUnload() {
    var _this$animateArticle;
    this.socialShare && this.socialShare();
    (_this$animateArticle = this.animateArticle) === null || _this$animateArticle === void 0 ? void 0 : _this$animateArticle.destroy();
  }
});
